
import { mapGetters, mapMutations } from 'vuex'
import catalogFiltersParserQueryParams from '../CatalogFilters/mixins/catalog-filters-parser-query-params'
import CatalogPaginationSize from './CatalogPaginationSize'

export default {
  name: 'CatalogPagination',
  components: { CatalogPaginationSize },
  mixins: [catalogFiltersParserQueryParams],
  props: {
    lastPage: {
      type: Number,
      default: 20,
    },
  },
  computed: {
    ...mapGetters({
      pageNumber: 'catalog/pageNumber',
    }),
    model: {
      get() {
        return this.pageNumber
      },
      set(number = 0) {
        if (number !== this.pageNumber) {
          this.setPageNumber(number)
        }
      },
    },
  },
  methods: {
    ...mapMutations({
      setPageNumber: 'catalog/SET_PAGE_NUMBER',
    }),
  },
}
